<template>
  <section class="jsk-block">
    <div class="container">
      <div class="row ">
        <div class="col-12 col-lg-7 col-md-6">
          <h2>{{ $t("whatisweb.title") }}</h2>
          <p class="h4">HTML + CSS + JS</p>
          <p class="mt-3">{{ $t("whatisweb.subtitle") }}</p>
          <p>{{ $t("whatisweb.subtitle2") }}</p>

        </div>
        <div class="col-12 col-lg-5 col-md-6">
          <img src="./../assets/images/services/what-is-web.png" class="img-fluid">     
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "aboutWeb"
};
</script>